export const checkoutAppId = "wvus-flex-checkout-app";
